// extracted by mini-css-extract-plugin
export default {"responsivestack":"About_responsivestack__Voflv","stackcontainer":"About_stackcontainer__Ogmr5","responsivestackitem":"About_responsivestackitem__zvrKs"};